import React from "react"

import styles from './ToolBar.module.scss'


function ToolBar(props) {
    return (
        <div className={styles.toolBar}>
                {props.children}
        </div>
    )
}

export default ToolBar